import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import AlertContext from "../../../../../Context/Alert/AlertContext";
import { BaseURL } from "../../../../../Files/BaseURL";

const CompanyDescription = () => {
  const navigate = useNavigate();
  const { showAlert } = useContext(AlertContext);

  // State variables for form fields
  const [description, setDescription] = useState("");
  const [services, setServices] = useState("");
  const [promotionalMaterials, setPromotionalMaterials] = useState(false);
  const [advertisingPrograms, setAdvertisingPrograms] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate form inputs
    const validationErrors = {};
    if (!description.trim()) {
      validationErrors.description = "Description is required.";
    }
    if (!services.trim()) {
      validationErrors.services = "Services are required.";
    }

    setErrors(validationErrors);

    // If there are validation errors, do not proceed
    if (Object.keys(validationErrors).length > 0) {
      showAlert("Please fix the errors in the form.", "danger");
      return;
    }

    setIsSubmitting(true);

    try {
      const authToken = localStorage.getItem("p@token");
      const response = await fetch(`${BaseURL}/api/business/companysetup/Descriptionsetup`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "auth-token": authToken,
        },
        body: JSON.stringify({
          Description: description,
          CompanyServices: services,
        }),
      });

      const result = await response.json();

      if (response.ok) {
        showAlert(result.message, "success");
        navigate("/profileCreation/company/upload"); // Navigate to the next step
      } else {
        showAlert(result.message || "Failed to save company information.", "danger");
      }
    } catch (error) {
      console.error("Error:", error);
      showAlert("An error occurred. Please try again.", "danger");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      {/* Progress Bar */}
      <div className="h-2 w-full bg-neutral-200 dark:bg-neutral-600">
        <div className="h-2 bg-green-500" style={{ width: "70%" }}></div>
      </div>

      {/* Form Container */}
      <div className="py-2 flex justify-center font-pop items-center w-[90%] md:w-[60%] xl:w-[30%] m-auto">
        <div className="card bg-white p-8 rounded-lg shadow-md w-full">
          <h2 className="text-2xl font-bold mb-4 text-center">Company Profile</h2>

          {/* Back Button */}
          <p
            className="mb-6 cursor-pointer text-primarygreen"
            onClick={() => navigate("/profileCreation/company/shareholder")}
          >
            <span>&#60;</span> Back
          </p>

          {/* Form */}
          <form className="flex flex-col gap-4" onSubmit={handleSubmit}>
            {/* Description */}
            <div className="flex flex-col gap-1">
              <label htmlFor="description" className="text-gray-700">
                Can you provide a brief description of your company?
              </label>
              <textarea
                id="description"
                name="description"
                placeholder="Description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className={`w-full px-6 border-2 ${
                  errors.description ? "border-red-500" : "border-transparent"
                } font-pop text-lg rounded-2xl bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
                rows="5"
              ></textarea>
              {errors.description && <p className="text-red-500">{errors.description}</p>}
            </div>

            {/* Services */}
            <div className="flex flex-col gap-1">
              <label htmlFor="services" className="text-gray-700">
                What products or services does your company offer?
              </label>
              <textarea
                id="services"
                name="services"
                placeholder="Services"
                value={services}
                onChange={(e) => setServices(e.target.value)}
                className={`w-full px-6 border-2 ${
                  errors.services ? "border-red-500" : "border-transparent"
                } font-pop text-lg rounded-2xl bg-[#E8E8E8] py-2 focus:border-primarygreen focus:outline-none`}
                rows="5"
              ></textarea>
              {errors.services && <p className="text-red-500">{errors.services}</p>}
            </div>

            {/* Promotional Materials Checkbox */}
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="promotionalMaterials"
                checked={promotionalMaterials}
                onChange={(e) => setPromotionalMaterials(e.target.checked)}
                className="h-4 w-4 text-primarygreen border-gray-300 rounded focus:ring-primarygreen"
              />
              <label htmlFor="promotionalMaterials" className="text-gray-700">
                Would you like your company to be mentioned in our promotional materials or on our website?
              </label>
            </div>

            {/* Advertising Programs Checkbox */}
            <div className="flex items-center gap-2">
              <input
                type="checkbox"
                id="advertisingPrograms"
                checked={advertisingPrograms}
                onChange={(e) => setAdvertisingPrograms(e.target.checked)}
                className="h-4 w-4 text-primarygreen border-gray-300 rounded focus:ring-primarygreen"
              />
              <label htmlFor="advertisingPrograms" className="text-gray-700">
                Are you interested in participating in advertising programs or partnerships?
              </label>
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className={`my-4 bg-green-500 ${
                isSubmitting
                  ? "opacity-50 cursor-not-allowed"
                  : "hover:bg-transparent hover:bg-white-500"
              } font-semibold hover:text-black py-2 px-4 border border-black-500 hover:border-green-500 rounded-full w-full text-white animate__animated animate__backInUp transition duration-300`}
            >
              {isSubmitting ? "Submitting..." : "Create"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default CompanyDescription;
